import { useQuery } from "@tanstack/react-query";
import { getAllStudentEnrollments } from "../../api/apiStudentEnrollments";
import i18next from "i18next";
export function useGetStudentEnrollments(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({ queryKey: ["studentEnrollments", page, perPage, filters, i18next.language], queryFn: () => getAllStudentEnrollments(page, perPage, filters), retry: false });
    return { isLoading, error, enrollments: data?.data?.items || [], meta: data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 } };
}
